export default "__VITE_ASSET__7168f0b8__"